<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('personal.title') }}
    </h2>

    <div class="form-grid">
      <div class="form_group">
        <label>{{ t('personal.passport') }}</label>
        <input
          @input="clearError('personal.passport')"
          type="text"
          :placeholder="t('personal.passport')"
          v-model="form.passport" 
          :class="{ 'is-invalid': formErrors.has('personal.passport') }"/>
        <p class="invalid-feedback" v-if="formErrors.has('personal.passport')">
          {{ t(formErrors.first('personal.passport')) }}
        </p>
      </div>
      <div class="form_group">
        <label>{{ t('personal.firstName') }}</label>
        <input
          @input="clearError('personal.firstName')" 
          type="text"
          :placeholder="t('personal.firstName')"
          v-model="form.firstName" 
          :class="{ 'is-invalid': formErrors.has('personal.firstName') }"/>
        <p class="invalid-feedback" v-if="formErrors.has('personal.firstName')">
          {{ t(formErrors.first('personal.firstName')) }}
        </p>
      </div>
      <div class="form_group">
        <label>{{ t('personal.lastName') }}</label>
        <input
          @input="clearError('personal.lastName')"
          type="text"
          :placeholder="t('personal.lastName')"
          v-model="form.lastName" 
          :class="{ 'is-invalid': formErrors.has('personal.lastName') }" />
        <p class="invalid-feedback" v-if="formErrors.has('personal.lastName')">
          {{ t(formErrors.first('personal.lastName')) }}
        </p>
      </div>
      <div class="form_group">
        <label>{{ t('personal.dob') }}</label>
        <input
          @input="clearError('personal.dob')" 
          type="date"
          :min="minBirthDate"
          :max="maxBirthDate"
          v-model="form.dob" 
          :class="{ 'is-invalid': formErrors.has('personal.dob') }"/>
        <p class="invalid-feedback" v-if="formErrors.has('personal.dob')">
          {{ t(formErrors.first('personal.dob')) }}
        </p>
      </div>
      <div class="form_group">
        <label>{{ t('personal.gender') }}</label>
        <select 
        id="gender"
        v-model="form.gender"
        @input="clearError('personal.gender')" 
        :class="{ 'is-invalid': formErrors.has('personal.gender') }">
          <option value="">{{ t('common.please_select') }}</option>
          <option value="female">{{ t('gender.female') }}</option>
          <option value="male">{{ t('gender.male') }}</option>
        </select>
        <p class="invalid-feedback" v-if="formErrors.has('personal.gender')">
          {{ t(formErrors.first('personal.gender')) }}
        </p>
      </div>
    </div>
  </section>
</template>
<script setup>
import Error from '@/utils/Error';
import { onMounted, reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const props = defineProps({
  modelValue: {
    type:Object,
  },
  formErrors:{
    type:Object,
    required:false,
    default:reactive(new Error({}))
  }
})
onMounted(async ()=>{
});
const emit = defineEmits(['update:modelValue','removeError']);
const form = reactive({gender: ""},{...props.modelValue });

const today = new Date();
const maxBirthDate = new Date(
  today.getFullYear()-18, today.getMonth(), today.getDate()
).toISOString().split('T')[0];

const minBirthDate = new Date(
  today.getFullYear() - 65,
  today.getMonth(),
  today.getDate()+1
).toISOString().split('T')[0];

watch( form, (val) => emit('update:modelValue', val),
  { deep: true } //Watcher with a reactive source
);

watch(() => props.modelValue, // getter based watcher
(newValue) => {
    Object.assign(form, { ...newValue });
}, { deep: true, immediate: true });

const clearError = async(name)=>{
	emit("removeError",name)
}
</script>
<style>
.card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.form-heading {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1f2937;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
}

@media (min-width: 768px) {
  .form-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>